module.exports = __webpack_public_path__ + "img/189.9f78808e.jpg";